export enum LayoutEnum {
    HIGHLIGHT = 'highlight',
    TILED9 = 'tiled9',
    TILED4 = 'tiled4'
}